import React, { useState } from "react";
import swal from "sweetalert";
import { useQuery, useDelete } from "seed/gql";
import { DELETE_PARTICIPANT_ROLE } from "seed/gql/queries";
import l from "components/util/l";
import View from "components/presentation/sections/settings/roles/Roles.view";

function Roles({ 
  flow,
  onlyAdminRoles
}) {

  const [activeEditingRole, setActiveEditingRole] = useState(null);
  const [isCreateModalShown, setCreateModalShown] = useState(false);
  const [isEditModalShown, setEditModalShown] = useState(false);

  const [callDelete] = useDelete(DELETE_PARTICIPANT_ROLE, {
    onCompleted: () => {
      reqRoles.refetch();
    },
    onError: (error) => {
      swal("Error", l("No fue posible eliminar el rol%PA068"), "error");
      console.error(l("Error al eliminar el rol%PA069", error));
    },
  });

  let rolesFilter = `flow.id=${flow.id}`;
  if (onlyAdminRoles != null)
    rolesFilter += ` AND is_admin=${onlyAdminRoles ? 'true' : 'false'}`;

  const reqRoles = useQuery(`{
    participantRoles {
      name
      uiSettings
    }
  }`, rolesFilter);

  const onClickDeleteRole = (roleId) => {
    swal({
      title: l("¿Está seguro de eliminar el rol?%PA070"),
      text: l("No podrá recuperar el rol una vez eliminado%PA071"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        callDelete({ id: roleId });
      }
    });
  }

  const onClickOpenCreateModal = () => {
    setCreateModalShown(true);
  }
  const onCloseCreateModal = () => {
    setCreateModalShown(false);
  }

  const onClickOpenEditModal = (roleId) => {
    setActiveEditingRole(roleId)
    setEditModalShown(true);
  }

  const onCloseEditModal = () => {
    setActiveEditingRole(null);
    setEditModalShown(false);
  }

  if (reqRoles.error) return "Error";

  const isLoading = reqRoles.loading;
  const { participantRoles = [] } = reqRoles.data;

  return (
    <View
      flow={flow}
      roles={participantRoles}
      activeEditingRole={activeEditingRole}
      onlyAdminRoles={onlyAdminRoles}
      isCreateModalShown={isCreateModalShown}
      isEditModalShown={isEditModalShown}
      isLoading={isLoading}
      reqRoles={reqRoles}
      onClickDeleteRole={onClickDeleteRole}
      onClickOpenCreateModal={onClickOpenCreateModal}
      onCloseCreateModal={onCloseCreateModal}
      onClickOpenEditModal={onClickOpenEditModal}
      onCloseEditModal={onCloseEditModal}
    />
  );
}

export default Roles;